import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useShowZeroScoreLogs() {
  const value = useCbhFlag(CbhFeatureFlag.CLIPBOARD_SCORE_REDESIGN, {
    defaultValue: { enabled: false },
  });

  return value.enabled && Boolean(value.scoreLogs);
}
